// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/global.css");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../css-loader/dist/cjs.js??ref--6-1!../../../../postcss-loader/src/index.js!../global/variables.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".description_d3f {\n  margin-top: 8px;\n\n  font-size: 13px;\n\n  font-size: var(--ring-font-size);\n}\n", ""]);
// Exports
exports.locals = {
	"unit": "" + ___CSS_LOADER_ICSS_IMPORT_0___.locals["unit"] + "",
	"description": "description_d3f"
};
module.exports = exports;
